import { render, staticRenderFns } from "./polararea.vue?vue&type=template&id=34352a06"
import script from "./polararea.vue?vue&type=script&lang=js"
export * from "./polararea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports